window._ = require('lodash');
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');
    require('datatables.net-zf');
    require('datatables.net-buttons-zf');
    require('datatables.net-responsive-zf');
    require('datatables.net-scroller-zf');
    require('datatables.net-searchbuilder-zf');
    //require('datatables.net-buttons/js/buttons.print.js');
    require('datatables.net-select-zf');
    require('datatables.net-searchpanes-zf');
    require('./select');
    require('foundation-sites');
    require('select2');
    require('jquery-ui/ui/widgets/datepicker.js');
    require('jquery-ui/ui/widgets/tooltip.js');
    require('jquery-mask-plugin');
    require('jquery-validation');
    //require('./sentry');
    // jQuery plugin to prevent double submission of forms
    window.$.fn.preventDoubleSubmission = window.jQuery.fn.preventDoubleSubmission = function() {
        window.$(this).on('submit', function(e) {
            const $form = window.$(e.target);
            // $form.validate();
            console.log($form);
            let confirmation = true;
            if ($form.hasClass('confirmThis')) {
                confirmation = window.confirm('Are you sure?');
            } if (!confirmation) {
                e.preventDefault();
            } else {
                window.$('#loader').css('display', 'inline');
                if ($form.data('submitted') === true) {
                    // Previously submitted - don't submit again
                    window.alert('Form already submitted. Please wait.');
                    e.preventDefault();
                } else {
                    // Mark it so that the next submit can be ignored
                    // ADDED requirement that form be valid
                    if ($form.valid()) {
                        //window.alert('Form already submitted. Please wait.');
                        $form.data('submitted', true);
                    }
                }
            }
        });

        // Keep chainability
        return this;
    };
} catch (e) {
}
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
